<template>
	<div class="faq-page">
		<div class="page-content animate__animated ">
			<!-- 页面标题 -->
			<div class="sec-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31224_6778/20.svg')"></el-image>
				<span>{{$t('other.t1')}}</span>
			</div>

			<!-- FAQ 白色卡片容器 -->
			<div class="faq-card">
				<!-- FAQ 列表 -->
				<div class="faq-list">
					
					<template v-for="(item,index) in goodsList">
						
						<div class="faq-item">
							<div class="faq-question" @click="toggleFaq(index)">
								<div class="q-tag">
									<el-image :src="require('@/static/CodeBuddyAssets/31224_6778/31.svg')"></el-image>
									<div class="txt">
										<span>Q{{index+1}}</span>
									</div>
								</div>
								<span class="question-text">{{item.title}}</span>
								<el-image
									class="arrow-icon"
									:class="{ 'is-expanded': expandedList[index] }"
									:src="require('@/static/CodeBuddyAssets/31224_6778/32.svg')"
								></el-image>
							</div>
							<div class="faq-answer" v-show="expandedList[index]">
								<div v-html="item.content"></div>
							</div>
						</div>

						<div v-if="index!=7" class="faq-divider"></div>
					
					</template>
					

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { 
	articlelist,
} from "/src/api/api.js"
export default {
	name: 'FAQ',
	data() {
		return {
			expandedList: [],
			goodsList:[],
		}
	},
	mounted() {
		this.articlelist()
	},
	methods: {
		// 列表
		async articlelist(){
			const res = await articlelist({
				categoryId:2
			})
			if(res.code==200){
				var expandedList = []
				res.rows.forEach((item,index)=>{
					if(index==0){
						expandedList.push(true)
					}else{
						expandedList.push(false)
					}
				})
				this.expandedList = expandedList
				this.goodsList = res.rows
			}else{this.Tips(res.msg,'error');}
		},
		// 开关
		toggleFaq(index) {
			this.$set(this.expandedList, index, !this.expandedList[index])
		}
	}
}
</script>

<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$text-dark: #333333;
$text-gray: #9A9DA7;
$border-color: #BBBBBB;
$page-bg: #F8F8F8;
$card-bg: #FFFFFF;

/* ========== 页面容器（仅主内容区）========== */
.faq-page {
	width: 100%;
	min-height: 14.04rem;
	background: $page-bg;
}

.page-content {
	width: 15.96rem;
	margin-top: 0.18rem;
	box-sizing: border-box;
}

/* ========== 区块标题 ========== */
.sec-title {
	display: flex;
	align-items: center;
	padding-left: 0.10rem;
	margin-bottom: 0.16rem;

	.el-image {
		width: 0.02rem;
		height: 0.20rem;
		margin-right: 0.08rem;
		display: block;
	}

	span {
		font-size: 0.20rem;
		font-weight: 500;
		color: $text-dark;
	}
}

/* ========== FAQ 卡片容器 ========== */
.faq-card {
	width: 15.96rem;
	background: $card-bg;
	border-radius: 0.12rem;
	padding: 0.22rem 0.28rem;
	box-sizing: border-box;
}

/* ========== FAQ 列表容器 ========== */
.faq-list {
	width: 100%;
}

/* ========== 单个 FAQ 项 ========== */
.faq-item {
	width: 100%;
}

/* ========== 问题行（Flex布局）========== */
.faq-question {
	display: flex;
	align-items: center;
	height: 0.78rem;
	cursor: pointer;
	user-select: none;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.8;
	}
}

/* Q 标签（Flex居中） */
.q-tag {
	display: flex;
	justify-content: flex-end;
	width: 0.275rem;
	height: 0.24rem;
	position: relative;
	
	.el-image {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}
	
	.txt{
		width: 25px;
		height: 18.5px;
		display: flex;
		align-items: center;
		justify-content: center;
		span {
			position: relative;
			z-index: 1;
			font-size: 0.11rem;
			font-weight: 700;
			color: #FFFFFF;
		}
	}
	
}

/* 问题文本 */
.question-text {
	font-size: 0.16rem;
	font-weight: 400;
	color: $text-dark;
	margin-left: 0.11rem;
	flex: 1;
}

/* 箭头图标（点击展开/收起） */
.arrow-icon {
	width: 0.30rem;
	height: 0.30rem;
	flex-shrink: 0;
	transition: transform 0.3s ease;

	&.is-expanded {
		transform: rotate(180deg);
	}
}

/* ========== 答案内容区 ========== */
.faq-answer {
	padding: 0.14rem 0 0.22rem 0.40rem;
	padding-top: 0;
	div {
		font-size: 0.16rem;
		font-weight: 400;
		color: $text-dark;
		line-height: 1.6;
		margin: 0;
	}
}

/* ========== 分隔线 ========== */
.faq-divider {
	width: 100%;
	height: 0.01rem;
	border-bottom: 1px dashed #bbb;
}
</style>
